<template>
  <Modal
    v-model="_value"
    width="400"
    title="ZT设置ADAS报警"
    @on-visible-change="visibleChange"
    ok-text="关闭"
    cancel-text="">
    <Form ref="setDriverCardParamsRef" v-model="setDriverCardParams" :label-width="150">
      <FormItem prop="alarmType" label="ADAS报警类型">
        <Select v-model="setDriverCardParams.alarmType" style="width: 220px;">
          <Option v-for="item in alarmTypeOptions" :value="item.value" :key="item.value">
            {{item.name}}
          </Option>
        </Select>
      </FormItem>
      <FormItem prop="enable" label="ADAS报警开关">
        <Select v-model="setDriverCardParams.enable" style="width: 220px;">
          <Option v-for="item in EnableOptions" :value="item.value" :key="item.value">
            {{item.name}}
          </Option>
        </Select>
      </FormItem>
      <FormItem prop="Sensitivity" label="设备灵敏度（单位：秒）">
        <Input v-model="setDriverCardParams.Sensitivity" placeholder="持续时间（S）" style="width: 220px;">
        </Input>
      </FormItem>
      <FormItem prop="Sensitivity" label="报警间隔（单位：秒）">
        <Input v-model="setDriverCardParams.AlarmInterval" placeholder="持续时间（S）" style="width: 220px;">
        </Input>
      </FormItem>
      <FormItem prop="Sensitivity" label="上传间隔（单位：秒）">
        <Input v-model="setDriverCardParams.UploadIntervalL" placeholder="持续时间（S）" style="width: 220px;">
        </Input>
      </FormItem>
      <FormItem prop="Sensitivity" label="叫声间隔（单位：秒）">
        <Input v-model="setDriverCardParams.VocieInterval" placeholder="持续时间（S）" style="width: 220px;">
        </Input>
      </FormItem>
      <Button type="primary" @click="onSendDriverCardParams">发送</Button>
    </Form>
  </Modal>
</template>

<script>

import Vue from 'vue'
import { mapActions } from 'vuex'
import store from '@/store'
import { genQueryParam, genSortParam } from '@/libs/queryparamhelper'

import MaintainOrderAddMaintainDeviceRecordModal from '@/view/om/components/maintain-order-add-maintain-device-record-modal'

export default {
  name: 'ztsetdriveradasalarmmodal',
  components: {

  },
  props: {
    initValue: null,
    terminalNumValue: null,
    value: {
      type: Boolean,
      default: false
    }
  },
  data () {
    return {
      setDriverCardParams: {
        id: null,
        alarmType: null,
        enable: 0,
        Sensitivity: 60,
        AlarmInterval: 60,
        UploadIntervalL: 60,
        VocieInterval: 60,
      },
      alarmTypeOptions: [
        {name: '前向碰撞', value: 0},
        {name: '车距过近', value: 1},
        {name: '车道偏离', value: 2},
        {name: '行人碰撞', value: 3},
      ],

      EnableOptions:[
        {name: '关闭报警', value: 0},
        {name: '开启报警', value: 1},
      ],
    }
  },
  methods: {
    ...mapActions([
      'VehicleInfoServ_SearchByName'
    ]),
    visibleChange (val) {
      if (val) {
        this.setDriverCardParams.id = this._initValue
        this.setDriverCardParams.alarmType = null
        this.setDriverCardParams.enable = 1
        this.setDriverCardParams.Sensitivity = 600
        this.setDriverCardParams.AlarmInterval = 600
        this.setDriverCardParams.UploadIntervalL = 600
        this.setDriverCardParams.VocieInterval = 600

      }
    },
    onCleanDriverCardParams () {
      this.setDriverCardParams.alarmType = null
      this.setDriverCardParams.enable = 1
      this.setDriverCardParams.Sensitivity = 600
      this.setDriverCardParams.AlarmInterval = 600
      this.setDriverCardParams.UploadIntervalL = 600
      this.setDriverCardParams.VocieInterval = 600
  },
    onSendDriverCardParams () {
      let content = "_CoMmAnD@XmL:<Param_AdasAlarmSet><MESSAGE_ID>1</MESSAGE_ID><MESSAGE_TYPE>2</MESSAGE_TYPE><id>"+this.setDriverCardParams.alarmType+"</id><AlarmEnable>"+this.setDriverCardParams.enable+"</AlarmEnable><Sensitivity>"+ this.setDriverCardParams.Sensitivity*10 +"</Sensitivity><AlarmInterval>"+ this.setDriverCardParams.AlarmInterval +"</AlarmInterval><UploadIntervalL>"+ this.setDriverCardParams.UploadIntervalL +"</UploadIntervalL><VocieInterval>"+ this.setDriverCardParams.VocieInterval +"</VocieInterval></Param_AdasAlarmSet>"


      console.log(content)
      store.dispatch('NetCommandServ_SendCommand', {
        params: { id: this._initValue, content: content, urgent: true }
      }).then(() => {
        this.$Message.success('发送成功')
      }).catch(err => {
        this.$Message.error(err)
      })
    }
  },
  computed: {
    _value: {
      get () {
        return this.value
      },
      set (val) {
        this.$emit('input', val)
        this.$emit('change', val)
      }
    },
    _initValue: {
      get () {
        return this.initValue
      },
      set (val) {
        // this.$emit('input', val);
        // this.$emit('change', val);
      }
    },
    _terminalNumValue: {
      get () {
        return this.terminalNumValue
      },
      set (val) {
        // this.$emit('input', val);
        // this.$emit('change', val);
      }
    }
  },
  mounted () {
    this.$nextTick(() => {

    })
  }
}
</script>
